import { filterWithPaginationStates, useFilterWithPaginationV2 } from 'hooks';
import { DEFAULT_PAGINATION, type FilterWithPaginationStateShape } from 'hooks/useFilterWithPagination';

export interface PersonsTableFilter {
  sort?: string;
}

export type PersonsFilterWithPaginationShape = FilterWithPaginationStateShape<PersonsTableFilter>;

const STATE_KEY = 'PersonsFilterState' as const;

export const DEFAULT_FILTER = {
  sort: 'name:desc',
};

const states = filterWithPaginationStates({
  domainKey: STATE_KEY,
  filterDefaultValue: DEFAULT_FILTER,
  paginationDefaultValue: DEFAULT_PAGINATION,
});

export const usePersonsFilterWithPagination = (): PersonsFilterWithPaginationShape => useFilterWithPaginationV2(states);
